import { Module } from '../Module';
import { _copy } from './functions/_copy';

export class CopyPageURL extends Module {
	initialize() {
		_copy();
	}
}
